angular.module("SettingsApp").run(["$http", "$rootScope",
    function ($http, $rootScope) {
        $http.defaults.xsrfCookieName = "csrftoken";
        $http.defaults.xsrfHeaderName = "X-CSRFToken";
        $rootScope.in_app_links_template = '/static/assets/khapps/settings_v2/general/partials/settings_in_app_links.html';
        $rootScope.in_app_add_button = '/static/assets/khapps/settings_v2/general/partials/settings_in_app_add_button.html';
    }]);